var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',[(!_vm.$isMobile)?_c('div',[_vm._v(" "+_vm._s(_vm.$content.nav)+" ")]):_vm._e(),_c('ul',_vm._l((_vm.$collections),function(collection){return _c('li',{key:collection.id},[_c('HomeCollectionItem',{attrs:{"collection":collection,"has-notice":true}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }